export default "__VITE_ASSET__oOLi$OE$__"